import { jsx as o, jsxs as F } from "react/jsx-runtime";
import { useTheme as Q, ThemeName as Z, BREAKPOINTS as G } from "@fcamna/shared-component-foundations";
import { c as a } from "./index-65016bfa.mjs";
import { forwardRef as J, useRef as U, useMemo as W } from "react";
import r, { styled as X, css as s } from "styled-components";
import { u as Y } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { c as M } from "./cloneSlots-333ddef1.mjs";
import { c as P } from "./combineRefs-90f27925.mjs";
import { b as tt } from "./useSlots-a1aa6a84.mjs";
import { u as et } from "./useSize-a56c9e53.mjs";
import { Disclosures as at } from "./disclosure.js";
import { Tag as k, TagsGroup as v } from "./tags.js";
import { Hero as ot } from "./hero.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./childrenCountCheck-785fa19a.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./image.js";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "./screenReaderOnly-fd82ed96.mjs";
const N = X(ot)`
  &.Card__Media {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Media)};
  }
`, p = ({
  shouldShowPlayButton: t,
  shouldShowOverlay: n,
  showPlayButton: i = t,
  showOverlay: d = n,
  className: C,
  ..._
}) => /* @__PURE__ */ o(
  N,
  {
    showPlaybackButton: i,
    className: a(["Card__Media", C]),
    ..._,
    hideOverlay: !0
  }
);
p.Image = N.Image;
p.Video = N.Video;
p.PlayBackButton = N.PlaybackButton;
var f = /* @__PURE__ */ ((t) => (t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t))(f || {});
const nt = r.div`
  &.CardGroupContainer {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.CardGroupContainer)};
  }
`, rt = ({
  className: t,
  style: n = {},
  gap: i,
  alignItems: d,
  justifyContent: C,
  margin: _,
  padding: T,
  ...m
}) => /* @__PURE__ */ o(
  nt,
  {
    ...m,
    className: a(["CardGroupContainer", t]),
    style: { ...n, gap: i, alignItems: d, justifyContent: C, margin: _, padding: T }
  }
), st = r.div`
  &.Card__container {
    ${({
  theme: {
    components: { card: t },
    componentStyles: n
  }
}) => s(t.Container, n)};
  }
`, it = r.div`
  &.Card {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Card)};
  }
`, mt = r.div`
  &.Card__content {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Content)};
  }
`, ct = r.h1`
  &.Card__title {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Title)};
  }
`, dt = r.div`
  &.Card__subtitle {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Subtitle)};
  }
`, lt = ({ headingLevel: t = "h1", ...n }) => /* @__PURE__ */ o(
  dt,
  {
    as: t,
    ...n,
    className: a(n.className, "Card__subtitle")
  }
), Ct = r.div`
  &.Card__body {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Body)}
  }
`, I = (t) => /* @__PURE__ */ o(
  Ct,
  {
    ...t,
    className: a(t.className, "Card__body")
  }
), _t = r.div`
  ${({
  theme: {
    components: { card: t }
  }
}) => s(t.BodySlot)};
`, ut = r.div`
  &.Card__footer {
    ${({
  theme: {
    components: { card: t }
  }
}) => s(t.Footer)}
  }
`, pt = (t) => /* @__PURE__ */ o(
  ut,
  {
    ...t,
    className: a(t.className, "Card__footer")
  }
), gt = r.div`
  &.Card__footer-link-container {
    ${({
  theme: {
    components: { card: t }
  }
}) => t.FooterLinkContainer}
  }
`, ht = (t) => /* @__PURE__ */ o(
  gt,
  {
    ...t,
    className: a(t.className, "Card__footer-link-container")
  }
), ft = { "1/1": "square", "16/9": "landscape" }, e = J(
  ({
    id: t,
    ratio: n = "1/1",
    orientation: i = f.VERTICAL,
    cardType: d = "default",
    children: C,
    right: _,
    title: T,
    titleProp: m = { size: "extraLarge", title: "", headingLevel: "h1" },
    disclosures: u,
    mediaProp: y = { alignment: _ ? "right" : "left" },
    fullHeight: x = !0,
    className: O,
    ...V
  }, A) => {
    const z = Y({ label: "Card" }), b = U(null), E = et(b), { themeName: w } = Q(), L = y.alignment === "right", $ = i === f.VERTICAL || E.width < (w === Z.FORD_PRO ? G.laptopMin : G.tabletMin), R = $ ? f.VERTICAL : i, l = tt(C, {
      Media: e.Media,
      Tags: e.Tag,
      TagGroup: e.TagGroup,
      Footer: [e.Footer, e.FooterLink]
    }), { tags: H, media: B, contents: j, footer: q } = W(() => {
      const g = M(l.Tags, (c, K) => /* @__PURE__ */ o(
        k,
        {
          ...c,
          className: a(["Card__Tag", c.className])
        },
        K
      )), S = M(l.TagGroup.at(-1), (c) => /* @__PURE__ */ o(
        v,
        {
          ...c,
          className: a(["Card__TagGroup", c.className]),
          _maxTagCount: 5
        }
      ));
      let h;
      g.length > 1 && !S ? h = /* @__PURE__ */ o(
        v,
        {
          className: "Card__TagGroup",
          visibleTags: 5,
          _maxTagCount: 5,
          children: g
        }
      ) : g.length === 1 && !S ? h = g : h = S;
      const D = M(l.Media.at(-1), (c) => /* @__PURE__ */ o(
        p,
        {
          ...c,
          className: a([`Card__Media--${d}`, `Card__Media--${i}`, c.className]),
          ratio: n
        }
      ));
      return {
        tags: h,
        media: D,
        contents: l.rest,
        footer: l.Footer
      };
    }, [l, d, i, n]);
    return /* @__PURE__ */ o(
      st,
      {
        ...V,
        ref: P(A, b),
        className: a(["Card__container", O]),
        ...z,
        children: /* @__PURE__ */ F(
          it,
          {
            id: t,
            className: a([
              "Card",
              `Card--${d}`,
              `Card--${R}`,
              `Card--${y.alignment}`,
              x && "Card--full-height"
            ]),
            children: [
              (!L || $) && B,
              /* @__PURE__ */ F(
                mt,
                {
                  title: T,
                  className: a([
                    "Card__content",
                    `Card__content--${d}`,
                    `Card__content--${R}`,
                    `Card__content--${ft[n]}`,
                    `Card__content--${y.alignment}`
                  ]),
                  children: [
                    H,
                    (m == null ? void 0 : m.title) && /* @__PURE__ */ o(
                      ct,
                      {
                        className: a(["Card__title", `Card__title--${m.size || "extraLarge"}`]),
                        as: m.headingLevel,
                        children: m.title
                      }
                    ),
                    j,
                    q,
                    u && /* @__PURE__ */ o(
                      at,
                      {
                        ...u,
                        className: a(["Card__disclosures", u == null ? void 0 : u.className])
                      }
                    )
                  ]
                }
              ),
              L && !$ && B
            ]
          }
        )
      }
    );
  }
);
e.Container = rt;
e.Media = p;
e.Tag = k;
e.SubTitle = lt;
e.TagGroup = v;
e.Body = I;
e.Footer = pt;
e.BodyContent = I;
e.BodySlot = _t;
e.FooterLink = ht;
export {
  e as Card
};
